import type { SupportedLocale } from './types'

/** BCP 47 tag for formatting dates in each UI language (client and server). */
export const DATE_LOCALE_TAGS: Record<SupportedLocale, string> = {
  en: 'en-US', cs: 'cs-CZ', de: 'de-DE', es: 'es-ES', fr: 'fr-FR',
  it: 'it-IT', nl: 'nl-NL', pl: 'pl-PL', pt: 'pt-PT',
}

export function dateLocaleTag(locale: SupportedLocale): string {
  return DATE_LOCALE_TAGS[locale] ?? 'en-US'
}
